import EditLicenseModal from 'components/EditLicenseModal'
import EditProductUserModal from 'components/EditProductUserModal'
import RebalanceSubscriptionModal from 'containers/css-admin/subscriptions/rebalance/RebalanceSubscriptionModal'
import EditTrainingModal from 'components/EditTrainingModal'
import RemoveUserTraining from 'components/RemoveUserTrainingModal'

export const modalMap = {
  editLicense: {
    component: EditLicenseModal,
    size: 'lg',
  },
  editProductUserModal: {
    component: EditProductUserModal,
  },
  RebalanceSubscriptionModal: {
    component: RebalanceSubscriptionModal,
    size: 'xl',
  },
  editTrainingModal: {
    component: EditTrainingModal,
    size: 'lg',
  },
  removeUserTrainingModal: {
    component: RemoveUserTraining,
  },
}
